<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ fe_part.part_id ? $t("lang.edit_fe_part") : $t("lang.add_fe_part") }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-btn-refresh v-if="fe_part.part_id && fe_part.part_id > 0" @invoke-method="dbGetFePart(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="fe_part.part_id && fe_part.part_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <template>
                                    <v-list-tile>
                                        <v-list-tile-title> Clone Item </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                                <template v-if="fe_part.part_id">
                                    <v-list-tile @click="changeFePartActiveInactive()">
                                        <v-list-tile-title>
                                            {{ fe_part.active == 0 ? $t(`lang.mark_as_active`) : $t(`lang.mark_as_inactive`) }}
                                        </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                                <template v-if="hasPerm('fe_parts.update')">
                                    <div v-for="item in fe_part_status_options" :key="item.option_id">
                                        <v-list-tile @click="editStatus(item)" v-if="item.option_id != currObjField('status_id')">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('fe_parts.delete')">
                                    <v-list-tile @click="$refs.delete_fe_part.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                                <template>
                                    <v-divider class="ml-3 mr-3"></v-divider>
                                    <v-list-tile @click.stop="dialog = true">
                                        <v-list-tile-title> Purchase History </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'fe_parts' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-container fluid grid-list-xl :class="$bp.smallScreen ? 'pl-0 pr-0' : null">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-flex class="xs12" pb-0 mb-0>
                        <v-card elevation="0">
                            <div v-if="fe_part.active" class="ribbon ribbon-top-right" :class="`ribbon-${fe_part.status_class}`">
                                <span class="ribbon-span">{{ fe_part.active == "1" ? $t("lang.active") : $t("lang.inactive") }}</span>
                            </div>
                            <vue-perfect-scrollbar
                                class="scroll-area"
                                :style="$bp.xs ? null : 'max-height: calc(100vh - 230px); min-height: calc(100vh - 230px)'"
                                style="overflow: hidden"
                            >
                                <v-card-text pa-0>
                                    <v-form ref="formFePart">
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null" style="margin: 0px">
                                            <v-flex xs12 sm3 v-if="fe_part.part_id" style="height: 100%">
                                                <v-layout row wrap>
                                                    <v-flex xs12>
                                                        <div class="carousel">
                                                            <div class="carousel-navigation">
                                                                <v-btn icon @click="prevSlide">
                                                                    <v-icon class="material-icons-outlined">chevron_left</v-icon>
                                                                </v-btn>
                                                            </div>

                                                            <div class="carousel-content">
                                                                <div
                                                                    v-if="partImageProgress == true"
                                                                    style="
                                                                        width: 256px;
                                                                        height: 256px;
                                                                        justify-content: center;
                                                                        align-items: center;
                                                                        display: flex;
                                                                    "
                                                                >
                                                                    <v-progress-circular size="48" indeterminate color="primary"></v-progress-circular>
                                                                </div>
                                                                <img
                                                                    v-else
                                                                    v-for="(image, index) in fe_part.files"
                                                                    :key="index"
                                                                    :src="image.full_path"
                                                                    :class="{ active: currentIndex === index }"
                                                                    :style="{ width: currentIndex === index ? '100%' : '0%' }"
                                                                    class="thumbnail"
                                                                    v-image-magnifier
                                                                />
                                                            </div>
                                                            <div class="carousel-navigation">
                                                                <v-btn icon @click="nextSlide">
                                                                    <v-icon class="material-icons-outlined">chevron_right</v-icon>
                                                                </v-btn>
                                                            </div>
                                                        </div>
                                                        <input ref="partImageInput" type="file" style="display: none" @change="handleFileUpload" />
                                                        <v-btn color="primary" @click="triggerPartImageInput">Upload Images</v-btn>
                                                        <v-divider horizontal v-if="fe_part.files != null && fe_part.files.length > 0"></v-divider>
                                                        <div class="carousel-previews">
                                                            <div class="carousel-preview" v-for="(image, index) in fe_part.files" :key="index">
                                                                <img
                                                                    :src="image.thumb_path"
                                                                    :class="{ active: currentIndex === index }"
                                                                    @click="changeSlide(index)"
                                                                    elevation="2"
                                                                />
                                                                <transition name="icon-transition">
                                                                    <v-icon
                                                                        key="default"
                                                                        @mouseenter="fe_part_img_preview_remove_hover = true"
                                                                        @mouseleave="fe_part_img_preview_remove_hover = false"
                                                                        @click="handleDeleteFile(image.file_id)"
                                                                        class="material-symbols-outlined carousel-preview-remove"
                                                                        >cancel</v-icon
                                                                    >
                                                                </transition>
                                                            </div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 :class="fe_part.part_id ? 'sm9' : null">
                                                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="fe_part.name"
                                                            :label="`${$t('lang.name')} *`"
                                                            :counter="showCounter(fe_part.name, 'fe_parts.name')"
                                                            :rules="ifValid('fe_parts.name')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6>
                                                        <v-text-field
                                                            v-model="fe_part.hts_code"
                                                            :label="`${$t('lang.hts_code')}`"
                                                            :counter="showCounter(fe_part.hts_code, 'fe_parts.hts_code')"
                                                            :rules="ifValid('fe_parts.hts_code')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm4>
                                                        <bc-autocomplete
                                                            v-model="fe_part.mfg_id"
                                                            :label="`${$t('lang.mfg_id')}`"
                                                            :items="mfgs"
                                                            item-value="company_id"
                                                            item-text="company"
                                                            :rules="ifValid('fe_parts.mfg_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm8 style="display: flex !important">
                                                        <v-checkbox
                                                            v-model="fe_part.is_non_stock"
                                                            :label="$t('lang.is_non_stock')"
                                                            :rules="ifValid('fe_parts.is_non_stock')"
                                                            true-value="1"
                                                            false-value="0"
                                                        >
                                                        </v-checkbox>
                                                        <v-checkbox
                                                            v-model="fe_part.is_raw_material"
                                                            :label="$t('lang.is_raw_material')"
                                                            :rules="ifValid('fe_parts.is_raw_material')"
                                                            true-value="1"
                                                            false-value="0"
                                                        >
                                                        </v-checkbox>
                                                        <v-checkbox
                                                            v-model="fe_part.is_service"
                                                            :label="$t('lang.is_service')"
                                                            :rules="ifValid('fe_parts.is_service')"
                                                            true-value="1"
                                                            false-value="0"
                                                        >
                                                        </v-checkbox>
                                                        <v-checkbox
                                                            v-model="fe_part.is_global"
                                                            :label="$t('lang.is_global')"
                                                            :rules="ifValid('fe_parts.is_global')"
                                                            true-value="1"
                                                            false-value="0"
                                                        >
                                                        </v-checkbox>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            v-model="fe_part.model_number"
                                                            :label="`${$t('lang.model_number')} *`"
                                                            :counter="showCounter(fe_part.model_number, 'fe_parts.model_number')"
                                                            :rules="ifValid('fe_parts.model_number')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field
                                                            v-model="fe_part.part_assembly"
                                                            :label="`${$t('lang.part_assembly')}`"
                                                            :counter="showCounter(fe_part.part_assembly, 'fe_parts.part_assembly')"
                                                            :rules="ifValid('fe_parts.part_assembly')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="fe_part.old_control_number"
                                                            :label="`${$t('lang.old_control_number')}`"
                                                            :counter="showCounter(fe_part.old_control_number, 'fe_parts.old_control_number')"
                                                            :rules="ifValid('fe_parts.old_control_number')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="fe_part.web_url"
                                                            :label="`${$t('lang.web_url')}`"
                                                            :counter="showCounter(fe_part.web_url, 'fe_parts.web_url')"
                                                            :rules="ifValid('fe_parts.web_url')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <bc-combobox
                                                            v-model="fe_part.fe_part_category_mapping"
                                                            :label="$t('lang.categories')"
                                                            :items="fe_part_categories"
                                                            item-text="category_name"
                                                            item-value="category_id"
                                                            hide-selected
                                                            multiple
                                                            chips
                                                            @keydown.enter.stop
                                                        >
                                                            <template slot="no-data">
                                                                <v-list-tile>
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title> Category Not Found </v-list-tile-title>
                                                                    </v-list-tile-content>
                                                                </v-list-tile>
                                                            </template>
                                                            <template slot="selection" slot-scope="data">
                                                                <v-chip
                                                                    :selected="data.selected"
                                                                    close
                                                                    class="chip--select-multi pa-0"
                                                                    @input="removePartCategory(data.item.category_id)"
                                                                >
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title>{{ data.item.category_name }}</v-list-tile-title>
                                                                    </v-list-tile-content>
                                                                </v-chip>
                                                            </template>
                                                            <template slot="item" slot-scope="data">
                                                                <template>
                                                                    <v-list-tile-content>
                                                                        <v-list-tile-title v-html="data.item.category_name"></v-list-tile-title>
                                                                        <v-list-tile-sub-title
                                                                            style="font-size: 12px"
                                                                            v-html="data.item.category_description"
                                                                        ></v-list-tile-sub-title>
                                                                    </v-list-tile-content>
                                                                </template>
                                                            </template>
                                                        </bc-combobox>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-textarea
                                                            v-model="fe_part.notes"
                                                            :label="`${$t('lang.notes')}`"
                                                            :counter="showCounter(fe_part.notes, 'fe_parts.notes')"
                                                            :rules="ifValid('fe_parts.notes')"
                                                            rows="1"
                                                            auto-grow
                                                        >
                                                        </v-textarea>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider></v-divider>
                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                            <v-flex xs12>
                                                <v-card color="grey lighten-4">
                                                    <v-card-title>Sales</v-card-title>
                                                </v-card>
                                            </v-flex>
                                            <v-flex xs12 sm1 style="min-height: 70px; padding-top: 15px">
                                                <v-checkbox
                                                    v-model="fe_part.is_taxable"
                                                    :label="$t('lang.is_taxable')"
                                                    :rules="ifValid('fe_parts.is_taxable')"
                                                    true-value="1"
                                                    false-value="0"
                                                >
                                                </v-checkbox>
                                            </v-flex>
                                            <v-flex xs12 sm11>
                                                <bc-autocomplete
                                                    v-model="fe_part.sales_account_id"
                                                    :label="`${$t('lang.sales_account_id')} *`"
                                                    :items="chartofaccounts"
                                                    item-value="account_id"
                                                    item-text="account_code_name"
                                                    :rules="ifValid('fe_parts.sales_account_id')"
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <v-text-field
                                                    v-model="fe_part.sales_sku"
                                                    :label="`${$t('lang.sales_sku')} *`"
                                                    :counter="showCounter(fe_part.sales_sku, 'fe_parts.sales_sku')"
                                                    :rules="ifValid('fe_parts.sales_sku')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                                <bc-autocomplete
                                                    v-model="fe_part.sales_unit"
                                                    :label="`${$t('lang.sales_unit')} *`"
                                                    :items="sales_units"
                                                    item-value="option_id"
                                                    item-text="option"
                                                    :rules="ifValid('fe_parts.sales_unit')"
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field
                                                    v-model="fe_part.sales_description"
                                                    :label="`${$t('lang.sales_description')}`"
                                                    :counter="showCounter(fe_part.sales_description, 'fe_parts.sales_description')"
                                                    :rules="ifValid('fe_parts.sales_description')"
                                                >
                                                </v-text-field>
                                            </v-flex>

                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    v-model="fe_part.sales_unit_weight"
                                                    :label="`${$t('lang.sales_unit_weight')} *`"
                                                    :counter="showCounter(fe_part.sales_unit_weight, 'fe_parts.sales_unit_weight')"
                                                    :rules="ifValid('fe_parts.sales_unit_weight')"
                                                    hide-details
                                                >
                                                    <div slot="append">
                                                        <bc-select
                                                            v-model="fe_part.sales_unit_weight_measure_id"
                                                            :label="`${$t('lang.unit')}`"
                                                            :items="uom_weights"
                                                            item-value="option_id"
                                                            item-text="option"
                                                            :rules="ifValid('fe_parts.sales_unit_weight_measure_id')"
                                                            hide-details
                                                        ></bc-select>
                                                    </div>
                                                </v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    v-model="fe_part.sales_markup"
                                                    :label="`${$t('lang.sales_markup')} *`"
                                                    :counter="showCounter(fe_part.sales_markup, 'fe_parts.sales_markup')"
                                                    :rules="ifValid('fe_parts.sales_markup')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 sm4>
                                                <v-text-field
                                                    prefix="$"
                                                    v-model="fe_part.sales_price"
                                                    :label="`${$t('lang.sales_price')} *`"
                                                    :counter="showCounter(fe_part.sales_price, 'fe_parts.sales_price')"
                                                    :rules="ifValid('fe_parts.sales_price')"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout ro wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                            <v-flex xs12>
                                                <v-card color="grey lighten-4">
                                                    <v-card-title>Purchase</v-card-title>
                                                </v-card>
                                            </v-flex>

                                            <v-flex xs12>
                                                <bc-autocomplete
                                                    v-model="fe_part.purchase_account_id"
                                                    autocomplete
                                                    :label="$t('lang.purchase_account_id')"
                                                    :items="chartofaccounts"
                                                    item-value="account_id"
                                                    item-text="account_code_name"
                                                    :rules="ifValid('fe_parts.purchase_account_id')"
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field
                                                    v-model="fe_part.purchase_description"
                                                    :label="`${$t('lang.purchase_description')}`"
                                                    :counter="showCounter(fe_part.purchase_description, 'fe_parts.purchase_description')"
                                                    :rules="ifValid('fe_parts.purchase_description')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-data-table
                                                    :headers="headers"
                                                    :items="fe_part.fe_part_vendor_mapping || []"
                                                    item-key="map_id"
                                                    :no-data-text="$t('lang.no_vendors')"
                                                    hide-actions
                                                >
                                                    <template slot="items" slot-scope="props">
                                                        <tr>
                                                            <td>
                                                                <bc-autocomplete
                                                                    v-model="props.item.vendor_id"
                                                                    :items="vendors"
                                                                    item-value="company_id"
                                                                    item-text="company"
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.vendor_id')"
                                                                    @change="handleVendorChange(props.index, props.item.vendor_id)"
                                                                ></bc-autocomplete>
                                                            </td>
                                                            <td>
                                                                <v-text-field
                                                                    v-model="props.item.sku"
                                                                    :counter="showCounter(props.item.sku, 'fe_parts.fe_part_vendor_mapping.sku')"
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.sku')"
                                                                ></v-text-field>
                                                            </td>
                                                            <td>
                                                                <v-text-field
                                                                    prefix="$"
                                                                    v-model="props.item.unit_price"
                                                                    :counter="showCounter(props.item.unit_price, 'fe_parts.fe_part_vendor_mapping.unit_price')"
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.unit_price')"
                                                                    number
                                                                ></v-text-field>
                                                            </td>
                                                            <td>
                                                                <bc-autocomplete
                                                                    v-model="props.item.purchase_unit"
                                                                    :items="sales_units"
                                                                    item-value="option_id"
                                                                    item-text="option"
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.purchase_unit')"
                                                                ></bc-autocomplete>
                                                            </td>
                                                            <td>
                                                                <v-text-field
                                                                    v-model="props.item.purchase_unit_weight"
                                                                    :counter="
                                                                        showCounter(
                                                                            props.item.purchase_unit_weight,
                                                                            'fe_parts.fe_part_vendor_mapping.purchase_unit_weight'
                                                                        )
                                                                    "
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.purchase_unit_weight')"
                                                                    number
                                                                >
                                                                    <div slot="append">
                                                                        <bc-select
                                                                            v-model="props.item.purchase_unit_weight_measure_id"
                                                                            :placeholder="`${$t('lang.unit')}`"
                                                                            :items="uom_weights"
                                                                            item-value="option_id"
                                                                            item-text="option"
                                                                            :rules="ifValid('fe_parts.fe_part_vendor_mapping.purchase_unit_weight_measure_id')"
                                                                            hide-details
                                                                        ></bc-select>
                                                                    </div>
                                                                </v-text-field>
                                                            </td>
                                                            <td>
                                                                <v-text-field
                                                                    v-model="props.item.lead_time"
                                                                    :key="props.index"
                                                                    :counter="showCounter(props.item.lead_time, 'fe_parts.fe_part_vendor_mapping.lead_time')"
                                                                    :rules="ifValid('fe_parts.fe_part_vendor_mapping.lead_time')"
                                                                    number
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="fe_part_vendor_radio">
                                                                <div style="display: flex; align-items: center; justify-content: center">
                                                                    <v-radio-group
                                                                        style="display: flex; align-items: center; justify-content: center"
                                                                        v-model="selectedPrimeVendor"
                                                                    >
                                                                        <v-radio :value="props.index"></v-radio>
                                                                    </v-radio-group>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <v-radio-group
                                                                    style="display: flex; align-items: center; justify-content: center"
                                                                    v-model="activeVendor"
                                                                >
                                                                    <v-radio
                                                                        style="pointer-events: none"
                                                                        :color="props.item.is_active == '1' ? 'success' : 'grey'"
                                                                        :value="activeVendor"
                                                                        v-readonly-click
                                                                    ></v-radio>
                                                                </v-radio-group>
                                                            </td>
                                                            <td>
                                                                <v-icon @click="removeRow(props.index)">delete</v-icon>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-layout row class="pa-0" justify-center>
                                                    <v-btn x-small raised color="primary" @click="addRow()">{{ $t("lang.add_another_vendor") }}</v-btn>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                                            <v-flex xs12>
                                                <v-card color="grey lighten-4">
                                                    <v-card-title>Inventory</v-card-title>
                                                </v-card>
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-checkbox
                                                    v-model="fe_part.is_trackable"
                                                    :label="$t('lang.track_inventory')"
                                                    :rules="ifValid('fe_parts.is_trackable')"
                                                    messages="You can not enable/disable inventory tracking once you have created transactions for this item"
                                                    true-value="1"
                                                    false-value="0"
                                                >
                                                </v-checkbox>
                                            </v-flex>

                                            <v-flex v-if="fe_part.is_trackable == '1'" xs12 sm6 :style="{ 'padding-bottom': $bp.smallScreen ? '0px' : '12px' }">
                                                <v-flex xs12>
                                                    <bc-autocomplete
                                                        v-model="fe_part.inventory_account_id"
                                                        :label="$t('lang.inventory_account_id')"
                                                        :items="chartofaccounts"
                                                        item-value="account_id"
                                                        item-text="account_name"
                                                        :rules="ifValid('fe_parts.inventory_account_id')"
                                                    ></bc-autocomplete>
                                                </v-flex>
                                                <v-flex xs12
                                                    ><v-text-field
                                                        v-model="fe_part.opening_stock"
                                                        :counter="showCounter(fe_part.opening_stock, 'fe_parts.opening_stock')"
                                                        :rules="ifValid('fe_parts.opening_stock')"
                                                        :label="`${$t('lang.opening_stock')}`"
                                                    ></v-text-field
                                                ></v-flex>
                                                <v-flex xs12
                                                    ><v-text-field
                                                        v-model="fe_part.stock_reorder_point"
                                                        :label="`${$t('lang.reorder_point')}`"
                                                        :counter="showCounter(fe_part.stock_reorder_point, 'fe_parts.stock_reorder_point')"
                                                        :rules="ifValid('fe_parts.stock_reorder_point')"
                                                    ></v-text-field
                                                ></v-flex>
                                                <v-flex xs12
                                                    ><v-text-field
                                                        v-model="fe_part.stock_quantity"
                                                        :label="`${$t('lang.stock_quantity')}`"
                                                        :counter="showCounter(fe_part.stock_quantity, 'fe_parts.stock_quantity')"
                                                        :rules="ifValid('fe_parts.stock_quantity')"
                                                    ></v-text-field
                                                ></v-flex>
                                            </v-flex>
                                            <v-flex v-if="fe_part.is_trackable == '1'" xs12 sm6 :style="{ 'padding-top': $bp.smallScreen ? '0px' : '12px' }">
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="fe_part.stock_bin_number"
                                                        :label="`${$t('lang.stock_bin_number')}`"
                                                        :counter="showCounter(fe_part.stock_bin_number, 'fe_parts.stock_bin_number')"
                                                        :rules="ifValid('fe_parts.stock_bin_number')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        prefix="$"
                                                        :label="`${$t('lang.cost_per_unit')}`"
                                                        v-model="fe_part.opening_stock_cost_per_unit"
                                                        :counter="showCounter(fe_part.opening_stock_cost_per_unit, 'fe_parts.opening_stock_cost_per_unit')"
                                                        :rules="ifValid('fe_parts.opening_stock_cost_per_unit')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="fe_part.stock_reorder_quantity"
                                                        :label="`${$t('lang.reorder_quantity')}`"
                                                        :counter="showCounter(fe_part.stock_reorder_quantity, 'fe_parts.stock_reorder_quantity')"
                                                        :rules="ifValid('fe_parts.stock_reorder_quantity')"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        v-model="fe_part.order_quantity"
                                                        :label="`${$t('lang.order_quantity')}`"
                                                        :counter="showCounter(fe_part.order_quantity, 'fe_parts.order_quantity')"
                                                        :rules="ifValid('fe_parts.order_quantity')"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-flex>
                                        </v-layout>
                                    </v-form>
                                </v-card-text>
                            </vue-perfect-scrollbar>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @mouseup.left="$router.push({ name: 'fe_parts' })" flat>{{ $t("lang.cancel") }}</v-btn>
                                <v-btn color="success" @click="saveFeParts">{{ $t("lang.save") }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

            <delete-confirmation-dialog
                ref="delete_fe_part"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_fe_part')"
                :message="$t('lang.delete_fe_part_confirm')"
                @onConfirm="deleteFeParts()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_part_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteFePartDetails()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_fe_part_image"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_fe_part_image')"
                :message="$t('lang.delete_fe_part_image_confirm')"
                @close="deleteFileId = null"
                @onConfirm="handleDeleteFile()"
            ></delete-confirmation-dialog>

            <!-- Dialog Model 1 -->
            <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" overlay="false" scrollable>
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-btn icon @click.native="dialog = false" dark>
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Purchase History</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items> </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                        <v-data-table
                            :headers="order_headers"
                            :items="[]"
                            item-key="order_detail_id"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            class="elevation-3"
                        >
                            <template slot="items" slot-scope="props">
                                <tr>
                                    <td>{{ props.item.sales_sku }}</td>
                                    <td>
                                        <v-text-field v-model="props.item.name" v-readonly-click></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="props.item.model_number" v-readonly-click></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="props.item.sales_unit" v-readonly-click></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="props.item.lead_time"></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            v-model="props.item.quantity"
                                            :label="`${$t('lang.quantity')} *`"
                                            @input="calculateTotalPartsCost(true)"
                                            :counter="showCounter(props.item.quantity, 'orders.order_details.quantity')"
                                            :rules="ifValid('orders.order_details.quantity')"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            prefix="$"
                                            v-model="props.item.cost_price"
                                            :label="`${$t('lang.cost_price')} *`"
                                            :counter="showCounter(props.item.cost_price, 'orders.order_details.cost_price')"
                                            :rules="ifValid('orders.order_details.cost_price')"
                                            @input="calculateTotalPartsCost(true)"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field
                                            prefix="$"
                                            v-model="props.item.unit_price"
                                            :label="`${$t('lang.unit_price')} *`"
                                            @input="calculateTotalPartsCost(true)"
                                            :counter="showCounter(props.item.unit_price, 'orders.order_details.unit_price')"
                                            :rules="ifValid('orders.order_details.unit_price')"
                                        ></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="props.item.line_total" v-readonly-click></v-text-field>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <div style="flex: 1 1 auto"></div>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],
            fe_part_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.name"), sortable: false, width: "7%" },
                { text: this.$t("lang.model_number"), sortable: false, width: "7%" },
                { text: this.$t("lang.mfg_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.vendor_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.file_id"), sortable: false, width: "7%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "7%" },
                { text: this.$t("lang.weight_pounds"), sortable: false, width: "7%" },
                { text: this.$t("lang.sales_price"), sortable: false, width: "7%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "7%" },
                { text: this.$t("lang.part_cost"), sortable: false, width: "7%" },
                { text: this.$t("lang.barcode"), sortable: false, width: "7%" },
                { text: this.$t("lang.active"), sortable: false, width: "7%" },
                { text: this.$t("lang.archive"), sortable: false, width: "7%" },
                { text: "", width: "3%", sortable: false },
            ],
            order_headers: [
                { text: this.$t("lang.part_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.part"), sortable: false, width: "20%" },
                { text: this.$t("lang.model_number"), sortable: false, width: "20%" },
                { text: this.$t("lang.sales_unit"), sortable: false, width: "5%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "5%" },
                { text: this.$t("lang.quantity"), sortable: false, width: "10%" },
                { text: this.$t("lang.cost_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.line_total"), sortable: false, width: "15%" },
            ],
            headers: [
                { text: this.$t("lang.vendor_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.vendor_sku"), sortable: false, width: "10%" },
                { text: this.$t("lang.unit_price"), sortable: false, width: "10%" },
                { text: this.$t("lang.purchase_unit"), sortable: false, width: "10%" },
                { text: this.$t("lang.purchase_unit_weight"), sortable: false, width: "10%" },
                { text: this.$t("lang.lead_time"), sortable: false, width: "10%" },
                { text: this.$t("lang.prime"), sortable: false, width: "5%" },
                { text: this.$t("lang.is_active"), sortable: false, width: "5%" },
                { text: "", sortable: false, width: "3%" },
            ],
            formData: {},
            fe_part: { fe_part_details: [], fe_part_category_mapping: [], fe_part_vendor_mapping: [] },
            file_name: "",
            dbGetFePart: _.debounce(this.getFePart, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
            vendors: [],
            dialog: false,
            currentIndex: 0,
            chartofaccounts: [],
            mfgs: [],
            fe_part_img_preview_remove_hover: false,
            partImageProgress: false,
            deleteFileId: null,
            selectedPrimeVendor: null,
            units_of_measure: [],
            activeVendor: true,
        };
    },
    directives: {
        "image-magnifier": {
            bind: function (el) {
                el.addEventListener("mousemove", zoomIn);
                el.addEventListener("mouseleave", zoomOut);

                function zoomIn(event) {
                    var img = event.target;
                    var posX = event.offsetX ? event.offsetX : event.pageX - img.offsetLeft;
                    var posY = event.offsetY ? event.offsetY : event.pageY - img.offsetTop;
                    img.style.transform = "scale(2)";
                    img.style.transformOrigin = posX + "px " + posY + "px";
                    img.style.transition = "transform 0.3s";
                    img.style.cursor = "zoom-in";
                }

                function zoomOut(event) {
                    var img = event.target;
                    img.style.transform = "scale(1)";
                    img.style.transformOrigin = "center center";
                    img.style.transition = "transform 0.3s";
                    img.style.cursor = "default";
                }
            },
            unbind: function (el) {
                function zoomIn(event) {}

                function zoomOut(event) {}
                el.removeEventListener("mousemove", zoomIn);
                el.removeEventListener("mouseleave", zoomOut);
            },
        },
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchFePart", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_part) {
                        this.fe_part = this.assignObj2(data.fe_part, this.rules_fe_parts);
                        if (this.fe_part.fe_part_vendor_mapping == null) this.fe_part.fe_part_vendor_mapping = [];
                        if (this.fe_part.fe_part_category_mapping == null) this.fe_part.fe_part_category_mapping = [];
                        this.selectedPrimeVendor = this.fe_part.fe_part_vendor_mapping.findIndex((item) => item.prime == 1);
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "fe_parts", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchFePart", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.fe_part) {
                        next((vm) => {
                            vm.fe_part = vm.assignObj2(data.fe_part, vm.rules_fe_parts);

                            if (vm.fe_part.fe_part_vendor_mapping != null && vm.fe_part.fe_part_vendor_mapping.length > 0) {
                                vm.selectedPrimeVendor = vm.fe_part.fe_part_vendor_mapping.findIndex((item) => item.prime == 1);
                            }
                            if (vm.fe_part.fe_part_vendor_mapping == null) vm.fe_part.fe_part_vendor_mapping = [];
                            if (vm.fe_part.fe_part_category_mapping == null) vm.fe_part.fe_part_category_mapping = [];
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "fe_parts", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_fe_parts: (state) => state.fe_parts.rules_fe_parts,
            fe_part_status_options: (state) => state.settings.fe_part_status_options,
            fe_parts: (state) => state.fe_parts.fe_parts,
            selectedFePart: (state) => state.fe_parts.selectedFePart,
            sales_units: (state) => state.options_categories.sales_units,
            uom_weights: (state) => state.options_categories.uom_weights,
            fe_part_categories: (state) => state.fe_part_categories.fe_part_category_options,
        }),
    },
    watch: {
        selectedPrimeVendor: {
            handler: function (newValue) {
                this.fe_part.fe_part_vendor_mapping.forEach((item, i) => {
                    if (i == newValue) {
                        item.prime = "1";
                    } else {
                        item.prime = "0";
                    }
                });
            },
            deep: true,
        },
    },
    methods: {
        ...mapActions([
            "fetchFePart",
            "saveFePart",
            "deleteFePart",
            "fetchOptions",
            "postFePartImage",
            "removeFePartImage",
            "fetchUnitsOfMeasure",
            "fetchFePartCategories",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        prevSlide() {
            if (this.currentIndex === 0) {
                this.currentIndex = this.fe_part.files.length - 1;
            } else {
                this.currentIndex--;
            }
        },
        nextSlide() {
            if (this.currentIndex === this.fe_part.files.length - 1) {
                this.currentIndex = 0;
            } else {
                this.currentIndex++;
            }
        },
        changeSlide(index) {
            this.currentIndex = index;
        },
        addRow() {
            if (!this.fe_part.fe_part_vendor_mapping || this.fe_part.fe_part_vendor_mapping == null) this.fe_part.fe_part_vendor_mapping = [];
            this.fe_part.fe_part_vendor_mapping.push({
                part_id: `${this.$route.params.id}`,
                vendor_id: "",
                sku: "",
                unit_price: "0.000",
                purchase_unit: "",
                purchase_unit_weight: "0.000",
                lead_time: "",
                prime: this.fe_part.fe_part_vendor_mapping.length <= 0 ? "1" : "0",
                is_active: "0",
            });

            if (this.fe_part.fe_part_vendor_mapping.length == 1) {
                this.selectedPrimeVendor = 0;
            }
        },
        removeRow: function (index) {
            let vendor_map = this.fe_part.fe_part_vendor_mapping[index];
            if (vendor_map.prime == 1) {
                let alert_message = this.$t("lang.unable_to_remove_prime_vendor");
                Vue.notify({
                    group: "loggedIn",
                    type: "error",
                    text: alert_message,
                });

                return;
            } else {
                this.fe_part.fe_part_vendor_mapping.splice(index, 1);
            }
        },
        getFePart(pg_refresh = false) {
            this.startLoader();

            this.fetchFePart({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.fe_part) {
                    this.fe_part = this.assignObj2(data.fe_part, this.rules_fe_parts);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        saveFeParts() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formFePart")) {
                    let body = this.prepForm(this.fe_part, this.rules_fe_parts);
                    if (body.fe_part_category_mapping == null) body.fe_part_category_mapping = [];
                    if (body.fe_part_vendor_mapping == null) body.fe_part_vendor_mapping = [];

                    this.saveFePart({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.fe_part) {
                            this.$router.push({ name: "fe_part", params: { id: data.fe_part.part_id } });
                        }
                    });
                }
            });
        },
        deleteFeParts() {
            this.deleteFePart({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.delete_fe_part_details.close();
                    this.validationOff();
                    this.$router.push({ name: "fe_parts" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getVendors() {
            this.$store
                .dispatch("fetchVendors", {
                    url: "vendors",
                    method: "get",
                    body: {
                        options: 1,
                    },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.vendors = data.vendors;
                })
                .finally(() => {});
        },
        getSalesUnits() {
            this.$store
                .dispatch("fetchSetting", {
                    url: "options?slug=sales_unit&sort_by=2",
                    method: "get",
                    dataProperty: "options",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.sales_units = data.options;
                });
        },
        getChartofAccounts() {
            this.$store
                .dispatch("fetchChartOfAccounts", {
                    url: "chart_of_accounts",
                    method: "get",
                    body: {
                        options: 1,
                    },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.chartofaccounts = data.chart_of_accounts;
                })
                .finally(() => {});
        },
        getManufacturers() {
            this.$store
                .dispatch("fetchManufacturers", {
                    url: "manufacturers",
                    method: "get",
                    body: {
                        options: 1,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.mfgs = data.manufacturers;
                    }
                });
        },
        triggerPartImageInput() {
            this.$refs.partImageInput.click();
        },
        handleFileUpload(event) {
            if (event.target.files.length == 0) return;
            this.partImageProgress = true;
            const file = event.target.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                const dataURL = reader.result; // Get the data string of the picture
                let body = { part_id: this.fe_part.part_id, photo_file: dataURL };
                this.postFePartImage({ body: body }).then((data) => {
                    this.fe_part.files = data.fe_part.files;
                    this.$refs.partImageInput.value = "";
                    this.currentIndex = this.fe_part.files.length - 1;
                    this.partImageProgress = false;
                });
            };

            reader.readAsDataURL(file);
        },
        handleDeleteFile(file_id) {
            if (this.deleteFileId == null) {
                this.deleteFileId = file_id;
                this.$refs.delete_fe_part_image.openDialog();
            } else {
                let body = { part_id: this.fe_part.part_id, file_id: this.deleteFileId };
                this.removeFePartImage({ body: body }).then((data) => {
                    this.fe_part = this.assignObj2(data.fe_part, this.rules_fe_parts);
                    this.currentIndex = 0;
                    this.deleteFileId = null;
                    this.$refs.delete_fe_part_image.close();
                });
            }
        },
        handleVendorChange(index, vendor_id) {
            let vendor_map = this.fe_part.fe_part_vendor_mapping[index];
            let vendor = this.vendors.find((item) => item.company_id == vendor_id);
            vendor_map.is_active = vendor.status;
        },
        removePartCategory(index) {
            // Remove the category from the array of dictionaries based on the category_id using .filter
            this.fe_part.fe_part_category_mapping = this.fe_part.fe_part_category_mapping.filter((item) => item.category_id != index);
        },
        changeFePartActiveInactive() {
            if (this.fe_part.active == "1") {
                this.fe_part.active = "0";
                this.fe_part.status_class = "red";
            } else {
                this.fe_part.active = "1";
                this.fe_part.status_class = "green";
            }

            let body = { part_id: `${this.$route.params.id}`, active: this.fe_part.active };
            this.saveFePart({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.fe_part) {
                    this.fe_part = this.assignObj2(data.fe_part, this.rules_fe_parts);
                }
            });
        },
        async refresh(force = false) {
            this.startLoader();
            if (this.sales_units == 0 || force == true) await this.fetchOptions({ body: { slug: "sales_units", sort_by: "0", options: 1 } });

            if (this.uom_weights == 0 || force == true) await this.fetchOptions({ body: { slug: "uom_weights", sort_by: "0", options: 1 } });
            if (this.units_of_measure.length == 0 || force == true) {
                // await this.fetchUnitsOfMeasure({ body: { options: 1 } })
                this.fetchUnitsOfMeasure({ body: { options: 1 } }).then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.units_of_measure = data.units_of_measure;
                });
            }

            if (this.fe_part_categories.length == 0 || force == true) await this.fetchFePartCategories({ body: { options: 1 } });

            this.finishLoader();
        },
    },
    created() {
        this.getCustomers();
        this.getVendors();
        this.getChartofAccounts();
        this.getManufacturers();
    },
};
</script>
<style lang="css" scoped>
.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
    margin-bottom: 0 !important;
}
.carousel {
    position: relative;
    width: 100%;
    overflow: hidden;
    display: grid;
    grid-template-columns: auto 1fr auto;
}

.carousel-previews {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.carousel-preview img {
    width: 40px !important;
    height: 40px !important;
    object-fit: cover;
    cursor: pointer;
    opacity: 0.5 !important;
    transition: opacity 0.2s ease-in-out;
}

.carousel-preview {
    position: relative;
    width: 40px;
    height: 40px;
}

.carousel-preview img:hover {
    opacity: 1 !important;
}

.carousel-preview:hover .carousel-preview-remove {
    visibility: visible;
}
.carousel-content {
    display: flex;
}

.carousel img {
    width: 100%;
    height: auto;
    opacity: 0;
    transition: opacity 0.3s;
    visibility: hidden;
}

.carousel img.active {
    opacity: 1;
    visibility: visible;
}

.carousel-preview img.active {
    opacity: 1 !important;
}

.carousel-navigation {
    width: 100%;
    display: flex;
    align-items: center;
    z-index: 1;
}

.carousel-navigation button {
    background: none;
    border: none;
    font-size: 24px;
    color: #000;
    cursor: pointer;
    padding: 0 10px;
    outline: none;
}
.material-symbols-outlined {
    font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 20;
}
.carousel-preview-remove {
    position: absolute;
    right: -8px;
    color: red !important;
    top: -8px;
    font-size: 16px;
    cursor: pointer;
    visibility: hidden;
    transition: all 0.2s ease-in-out;
}
.icon-transition-enter-active,
.icon-transition-leave-active {
    transition: all 0.2s ease-in-out;
}

.icon-transition-enter,
.icon-transition-leave-to {
    opacity: 0;
    /* transform: translateY(-10px); */
}
</style>
